import { buildGraphqlQuery } from '@ztechapps/common.utils'
import type { UseLeanMutationResult, UseMutationProps } from '@ztechapps/common.hook'
import { useMutation } from '@ztechapps/common.hook'
import type { PurchaseOrder, PurchaseOrderItem } from '@ztechapps/common.contract'

const addPurchaseOrderByVendorQuery = buildGraphqlQuery('PurchaseOrder', `_id code`)
export type PurchaseOrderMutationArgs = {
  productId: string
  price: number
  vendorCode: string
  vendorId: string
  quantity?: number
}

export const useAddPurchaseOrderByVendor = (
  props = {} as unknown as UseMutationProps
): UseLeanMutationResult<{ createPurchaseOrder: PurchaseOrder }, PurchaseOrderMutationArgs> => {
  const [executeIt, , mutationResult] = useMutation<{ createPurchaseOrder: PurchaseOrder }, PurchaseOrder>({
    ...addPurchaseOrderByVendorQuery.createConfig,
    ...props,
  })

  const onAdd = (input: PurchaseOrderMutationArgs) => {
    const price = input?.price ?? 0
    const quantity = input.quantity ?? 1
    const net = price * quantity
    const gross = net

    const newPurchaseOrderInput = {
      vendor: {
        _id: input.vendorId,
      },
      items: [
        {
          product: {
            _id: input.productId,
          },
          price,
          originalPrice: price,
          vendorProductCode: input?.vendorCode ?? null,
          quantity,
          net,
          gross,
        } as unknown as PurchaseOrderItem,
      ],
    } as unknown as PurchaseOrder

    return executeIt({ input: newPurchaseOrderInput })
  }

  return [onAdd, mutationResult]
}
